export default "__VITE_ASSET__CaRCKOx8__"